import { Icon } from '@ps/isp-web-component-library';
import { PriceBoost } from '@ps/isp-web-component-library/icons/PriceBoost';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTWCL_odds_boost } from './OddsBoostPanelHeader.messages.json';
import styles from './OddsBoostPanelHeader.scss';

export const OddsBoostPanelHeader: React.FC = () => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <header className={styles.oddsBoostHeader}>
      <span className={styles.oddsBoostTitle}>
        <Icon size="sm" icon={PriceBoost} label={formatMessage(TXTWCL_odds_boost)} />
        <span className={styles.oddsBoostTitleText}>
          <Translation {...TXTWCL_odds_boost} />
        </span>
      </span>
    </header>
  );
};
